export default [
  {
    title: "Data Management",
    customIcon: "DataManageSVG",
    children: [
      {
        title: "Merchant Selling Performance",
        route: "custom-module",
        path: "/custom-module/merchantsellingperformance",
      },
    ],
  },
];
